import common from './en/common';
import errors from './en/errors';
import home from './en/home';
import center from './en/center';
import custom from './en/custom';

export default {
    center: {
        ...center
    },
    home: {
        ...home
    },
    lang: {
        ...common,
        ...errors,
    },
    custom: {
        ...custom
    }
};
